import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SurveyDataInterface } from '../../classes';
import { SurveyDataResolve } from '../shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ViewResolve implements Resolve<{surveyData:Partial<SurveyDataInterface>}> {
    constructor(
        protected surveyData:SurveyDataResolve,
    ) {
    }
    resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ): Observable<{surveyData:Partial<SurveyDataInterface>}> {
        return this.surveyData.resolve(route, state)
        .pipe(
            map((surveyData)=>({surveyData}))
        )
    }
}
